import React from 'react';
import "./footer.css";

export default function Footer() {
    return(
        <div className="footer">
           <span className="copyright">&copy;</span> Your Personal Menu Recipe Book
        </div>
    )
}